import { ROLE } from "@/utils/constant";
import { SidebarMenuConfig } from "./nav-config";
import { createElement } from "react";
import { ChartColumn, List, MonitorCheck } from "lucide-react";
import { navAbdBackboneConfig } from "./nav-config-abd-backbone";

export const navE2EPhase2Config: SidebarMenuConfig[] = [
  {
    href: "#",
    label: "Backbone",
    child: [
      {
        href: "#",
        label: "Permit",
        child: [
          {
            href: "/hld/hld-list",
            label: "HLD List",
            icon: createElement(List, { width: 20, height: 20 }),
            allowedRoles: [ROLE.AGG_HLD, ROLE.HLD_VIEW],
          },
          {
            href: "/permit-rent/dashboard",
            label: "Dashboard Permit Rent",
            icon: createElement(ChartColumn, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.AGG_PERMIT_MONITORING,
              ROLE.AGG_PROJECT_MANAGER,
              ROLE.AGG_OPERATIONAL_LEAD,
              ROLE.AGG_FUNNEL_PROJECT,
              ROLE.VENDOR,
              ROLE.AGG_PERMIT_DISPATCH,
              ROLE.AGG_HLD,
              ROLE.HLD_VIEW,
              ROLE.PERMIT_AGG_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
          {
            href: "/permit-rent/permit-rent-list",
            label: "Rent List",
            icon: createElement(List, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.AGG_PERMIT_MONITORING,
              ROLE.AGG_PROJECT_MANAGER,
              ROLE.AGG_OPERATIONAL_LEAD,
              ROLE.AGG_FUNNEL_PROJECT,
              ROLE.VENDOR,
              ROLE.AGG_PERMIT_DISPATCH,
              ROLE.AGG_HLD,
              ROLE.HLD_VIEW,
              ROLE.PERMIT_AGG_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
          {
            href: "/permit-feeder/dashboard",
            label: "Dashboard Permit Feeder",
            icon: createElement(ChartColumn, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.VENDOR,
              ROLE.FEEDER_FUNNEL_PROJECT,
              ROLE.FEEDER_PERMIT_DISPATCH,
              ROLE.FEEDER_PERMIT_MONITORING,
              ROLE.FEEDER_HEAD_OF_PERMIT,
              ROLE.FEEDER_HEAD_OF_PROJECT,
              ROLE.PERMIT_FEEDER_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
          {
            href: "/permit-feeder/permit-feeder-list",
            label: "Feeder List",
            icon: createElement(List, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.VENDOR,
              ROLE.LM_FEEDER_DESIGN,
              ROLE.FEEDER_FUNNEL_PROJECT,
              ROLE.FEEDER_PERMIT_DISPATCH,
              ROLE.FEEDER_PERMIT_MONITORING,
              ROLE.FEEDER_HEAD_OF_PERMIT,
              ROLE.FEEDER_HEAD_OF_PROJECT,
              ROLE.PERMIT_FEEDER_VIEW,
              ROLE.APD_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
          {
            href: "/permit-fo-olt/dashboard",
            label: "Dashboard Permit FO OLT",
            icon: createElement(ChartColumn, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.VENDOR,
              ROLE.FOOLT_FUNNEL_PROJECT,
              ROLE.FOOLT_PERMIT_DISPATCH,
              ROLE.FOOLT_PERMIT_MONITORING,
              ROLE.FOOLT_HEAD_OF_PERMIT,
              ROLE.FOOLT_HEAD_OF_PROJECT,
              ROLE.PERMIT_FOOLT_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
          {
            href: "/permit-fo-olt/permit-fo-olt-list",
            label: "FO OLT List",
            icon: createElement(List, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.VENDOR,
              ROLE.LM_FEEDER_DESIGN,
              ROLE.FOOLT_FUNNEL_PROJECT,
              ROLE.FOOLT_PERMIT_DISPATCH,
              ROLE.FOOLT_PERMIT_MONITORING,
              ROLE.FOOLT_HEAD_OF_PERMIT,
              ROLE.FOOLT_HEAD_OF_PROJECT,
              ROLE.PERMIT_FOOLT_VIEW,
              ROLE.APD_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
          {
            href: "/permit-ring-bb/dashboard",
            label: "Dashboard Ring BB",
            icon: createElement(ChartColumn, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.VENDOR,
              ROLE.RING_FUNNEL_PROJECT,
              ROLE.RING_PERMIT_DISPATCH,
              ROLE.RING_PERMIT_MONITORING,
              ROLE.RING_HEAD_OF_PERMIT,
              ROLE.RING_HEAD_OF_PROJECT,
              ROLE.PERMIT_RING_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
          {
            href: "/permit-ring-bb/permit-ring-bb-list",
            label: "Ring BB List",
            icon: createElement(List, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.VENDOR,
              ROLE.RING_FUNNEL_PROJECT,
              ROLE.RING_PERMIT_DISPATCH,
              ROLE.RING_PERMIT_MONITORING,
              ROLE.RING_HEAD_OF_PERMIT,
              ROLE.RING_HEAD_OF_PROJECT,
              ROLE.PERMIT_RING_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
          {
            href: "/monitoring-bb-list",
            label: "Monitoring BB",
            icon: createElement(MonitorCheck, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.AGG_HLD,
              ROLE.AGG_FUNNEL_PROJECT,
              ROLE.AGG_PROJECT_MANAGER,
              ROLE.AGG_OPERATIONAL_LEAD,
              ROLE.AGG_PERMIT_MONITORING,
              ROLE.AGG_PERMIT_DISPATCH,
              ROLE.FEEDER_FUNNEL_PROJECT,
              ROLE.FEEDER_PERMIT_DISPATCH,
              ROLE.FEEDER_PERMIT_MONITORING,
              ROLE.FEEDER_HEAD_OF_PERMIT,
              ROLE.FEEDER_HEAD_OF_PROJECT,
              ROLE.FOOLT_FUNNEL_PROJECT,
              ROLE.FOOLT_PERMIT_DISPATCH,
              ROLE.FOOLT_PERMIT_MONITORING,
              ROLE.FOOLT_HEAD_OF_PERMIT,
              ROLE.FOOLT_HEAD_OF_PROJECT,
              ROLE.RING_FUNNEL_PROJECT,
              ROLE.RING_PERMIT_DISPATCH,
              ROLE.RING_PERMIT_MONITORING,
              ROLE.RING_HEAD_OF_PERMIT,
              ROLE.RING_HEAD_OF_PROJECT,
              ROLE.VENDOR,
              ROLE.HLD_VIEW,
              ROLE.PERMIT_AGG_VIEW,
              ROLE.PERMIT_FEEDER_VIEW,
              ROLE.PERMIT_RING_VIEW,
              ROLE.PERMIT_FOOLT_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
        ],
      },
      {
        href: "#",
        label: "APD",
        child: [
          {
            href: "/permit-backbone/dashboard",
            label: "Dashboard",
            icon: createElement(ChartColumn, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.VENDOR,
              ROLE.BB_DESIGN,
              ROLE.BB_COSTING,
              ROLE.APD_BB_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
          {
            href: "/permit-backbone/apd-bb-list",
            label: "BB List",
            icon: createElement(List, { width: 20, height: 20 }),
            allowedRoles: [
              ROLE.BB_DESIGN,
              ROLE.VENDOR,
              ROLE.BB_COSTING,
              ROLE.APD_BB_VIEW,
              ROLE.VENDOR_VIEW,
            ],
          },
        ],
      },
      ...navAbdBackboneConfig,
    ],
  },
];
